// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import VideosController from "./videos_controller"
application.register("videos", VideosController)

import VideoUploadController from "./video_upload_controller"
application.register("video-upload", VideoUploadController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import ScoreController from "./score_controller"
application.register("score", ScoreController)

import ScoreTimelineEditorController from "./score_timeline_editor_controller"
application.register("score-timeline-editor", ScoreTimelineEditorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import HighlightMarkerController from "./highlight_marker_controller"
application.register("highlight-marker", HighlightMarkerController)

import HighlightReorderController from "./highlight_reorder_controller"
application.register("highlight-reorder", HighlightReorderController)

import GoalMarkerController from "./goal_marker_controller"
application.register("goal-marker", GoalMarkerController)

// Components
import AlertComponentController from "./components/alert_component_controller"
application.register("alert-component", AlertComponentController)
